import * as R from 'ramda'

export const removeBase64Images = R.unless(
  R.isNil,
  R.replace(/<img.+?src="data:image\/\w+;base64.+?>/g, ''),
)
